module.exports = __webpack_public_path__ + "static/media/20.689afeb8.jpg";